import React, {Component} from 'react';

import Kosice from "../assets/img/kosice.jpg";
import Presov from "../assets/img/presov.jpg";
import Zilina from "../assets/img/zilina.jpg";
import Banska from "../assets/img/bb.jpg";
import Trnava from "../assets/img/trnava.jpg";
import Trencin from "../assets/img/trencin.jpg";
import Nitra from "../assets/img/nitra.jpg";
import Bratislava from "../assets/img/bratislava.jpg";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ReactFancyBox from 'react-fancybox'
import 'react-fancybox/lib/fancybox.css'

import {  isBrowser, isMobile} from "react-device-detect";


const opt = {
    0:{
        items:2
    },
    600:{
        items:3
    },
    1000:{
        items:4
    }
}

const countries = {
    kosice:{
        backgroundImage: 'url(' + Kosice + ')',
    },
    bratislava:{
        backgroundImage: 'url(' + Bratislava + ')',
    },
    banska:{
        backgroundImage: 'url(' + Banska + ')',
    },
    trencin:{
        backgroundImage: 'url(' + Trencin + ')',
    },
    trnava:{
        backgroundImage: 'url(' + Trnava + ')',
    },
    nitra:{
        backgroundImage: 'url(' + Nitra + ')',
    },
    zilina:{
        backgroundImage: 'url(' + Zilina + ')',
    },
    presov:{
        backgroundImage: 'url(' + Presov + ')',
    },

}

class SearchDetailHeader extends Component{
    constructor(props){
        super(props);


    }
    componentDidMount(){
        window.scrollTo(0,0);
    }


    render(){
        return(
            <div className="searchdetailheader">

                <Carousel obrazky={this.props.obrazky} />
            </div>
        );
    }
}

class Carousel extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        if(isMobile) {
            return (
                <div className="container">
                    <div className="row">
                        <h3 className="gal">Galéria</h3>
                        {
                            this.props.obrazky.map(obrazok => {

                                    if (obrazok.groupa == "slider") return (
                                        <div className="col-md-12 odd">
                                            <img className="obr" src={obrazok.image} />

                                        </div>
                                    );
                                }
                            )}
                    </div>
                </div>


            );
        }
        else{
            return(
                <OwlCarousel
                    className="owl-theme owl-second"
                    loop
                    margin={0}
                    autoplay={true}
                    nav={true}
                    dots={false}
                    autoplayTimeout={2500}
                    items={6}
                    responsive={opt}>


                    {
                        this.props.obrazky.map(obrazok => {

                                if (obrazok.groupa == "slider") return (
                                    <div className="item">

                                        <div className="obr" style={{backgroundImage: "url(" + obrazok.image + ")"}}></div>
                                    </div>
                                );
                            }
                        )}


                </OwlCarousel>
            );
        }

    }
}
export default SearchDetailHeader;